import Image from 'next/image'

export default function BrandReputationSection() {
  return (
    <section className='mx-auto gap-5 bg-neutral-100 px-4 py-10 md:px-16 md:py-20'>
      <div className='text-heading-6 md:text-heading-2 mb-2 text-center leading-none md:mb-10'>
        Uy tín của thương hiệu
      </div>
      <div className='mb-5 text-center text-base md:mb-10 md:mt-4 md:text-2xl'>
        Coolmate định vị mình là thương hiệu thời trang &ldquo;Made in Vietnam,
        Made by Vietnam&rdquo;, với 5 giá trị cốt lõi
      </div>
      <div
        className='gap-5 md:grid md:grid-cols-5'
        rel-script='brand-reputation'
      >
        <div>
          <Image
            src='https://mcdn.coolmate.me/image/March2025/mceclip8_12.png'
            alt='Brand Reputation'
            width={1000}
            height={1000}
            className='w-full'
          />
        </div>
        <div>
          <Image
            src='https://mcdn.coolmate.me/image/March2025/mceclip4_77.png'
            alt='Brand Reputation'
            width={1000}
            height={1000}
            className='w-full'
          />
        </div>
        <div>
          <Image
            src='https://mcdn.coolmate.me/image/March2025/mceclip5_20.png'
            alt='Brand Reputation'
            width={1000}
            height={1000}
            className='w-full'
          />
        </div>
        <div>
          <Image
            src='https://mcdn.coolmate.me/image/March2025/mceclip6_96.png'
            alt='Brand Reputation'
            width={1000}
            height={1000}
            className='w-full'
          />
        </div>
        <div>
          <Image
            src='https://mcdn.coolmate.me/image/March2025/mceclip1_38.png'
            alt='Brand Reputation'
            width={1000}
            height={1000}
            className='w-full'
          />
        </div>
      </div>
    </section>
  )
}
